import { render, staticRenderFns } from "./hcs.vue?vue&type=template&id=28c1991b&scoped=true&"
import script from "./hcs.vue?vue&type=script&lang=js&"
export * from "./hcs.vue?vue&type=script&lang=js&"
import style0 from "./hcs.css?vue&type=style&index=0&id=28c1991b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1991b",
  null
  
)

export default component.exports